import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { IndexedDBService } from "../../services/indexedDbService";

const DB_KEY = "offerCreditStore";
const db = new IndexedDBService();

export const creditOfferStore = create(
  devtools((set, get) => ({
    offerCreditStore: null,
    loading: false,

    loadOfertCredit: async () => {
      const existing = await db.getItemByKey(DB_KEY);
      if (existing?.value) {
        set({ offerCreditStore: existing.value });
      }
    },

    loadApprovedQuota: async () => {
      const existing = await db.getItemByKey(DB_KEY);
      if (existing?.value) {
        return existing.value.approvedQuota;
      }
    },

    saveOfertCredit: async (partialOrFullDraft) => {
      const current = get().offerCreditStore || {};
      const updated = {
        ...current,
        ...partialOrFullDraft,
        updatedAt: new Date().toISOString(),
      };
      set({ offerCreditStore: updated });
      try {
        await db.setItemByKey(DB_KEY, updated); // persiste
      } catch (err) {
        console.error("Error guardando offerCreditStore en IDB:", err);
      }
    },

    // 🔹 Limpiar offerCreditStore
    clearOfertCredit: async () => {
      await db.deleteItem(DB_KEY);
      set({ offerCreditStore: null });
    },
  }))
);
